import React from 'react';
import { MatrixBackground } from '../components/MatrixBackground';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { CredibilityBar } from '../components/CredibilityBar';
import { ProblemSection } from '../components/ProblemSection';
import { OpportunitySection } from '../components/OpportunitySection';
import { StorySection } from '../components/StorySection';
import { SolutionSection } from '../components/SolutionSection';
import { ProofSection } from '../components/ProofSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { FinalCTA } from '../components/FinalCTA';
import { FAQSection } from '../components/FAQSection';
import { FinalClose } from '../components/FinalClose';
import { Footer } from '../components/Footer';
import { SalesNotification } from '../components/SalesNotification';
import { LanguageSelector } from '../components/LanguageSelector';
import { useLanguage } from '../context/LanguageContext';
export function SalesPage() {
  const {
    showLanguageSelector,
    handleLanguageSelection
  } = useLanguage();
  return <div className="w-full bg-gradient-to-b from-black via-teal-950 to-black text-white" data-id="element-974">
      <MatrixBackground data-id="element-975" />
      <SalesNotification data-id="element-976" />
      {showLanguageSelector && <LanguageSelector onSelectLanguage={handleLanguageSelection} data-id="element-977" />}
      <div className="relative z-10" data-id="element-978">
        <HeroSection data-id="element-979" />
        <OpeningHook data-id="element-980" />
        <CredibilityBar data-id="element-981" />
        <ProblemSection data-id="element-982" />
        <OpportunitySection data-id="element-983" />
        <StorySection data-id="element-984" />
        <SolutionSection data-id="element-985" />
        <ProofSection data-id="element-986" />
        <WhatYouGetSection data-id="element-987" />
        <GuaranteeSection data-id="element-988" />
        <UrgencySection data-id="element-989" />
        <FinalCTA data-id="element-990" />
        <FAQSection data-id="element-991" />
        <FinalClose data-id="element-992" />
        <Footer data-id="element-993" />
      </div>
    </div>;
}